module.exports = __webpack_public_path__ + "img/fashion_35.2eab260e.jpg";